
    export default 
    {
    "h5_redirect": {
        "bind_tip": "Sind Sie sicher, dass Sie sich mit der E-Mail-Adresse { email } an das DSers-Konto binden möchten?"
    }
}